/* Loupe – recently viewed products (sections/recently-viewed.liquid).
   The section's inline script records product views in localStorage "loupe:recent" (newest first, max 12).
   This element renders them with one Section Rendering API request and hides the section when there is nothing to show. */
(() => {
  if (window.customElements.get('loupe-recently-viewed')) return;

  const KEY = 'loupe:recent', MAX = 12;
  const read = () => {
    try {
      const l = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(l) ? l.filter((h) => typeof h === 'string' && h && !/\s/.test(h)) : [];
    } catch (e) { return []; }
  };
  const write = (l) => { try { localStorage.setItem(KEY, JSON.stringify(l.slice(0, MAX))); } catch (e) {} };

  class LoupeRecentlyViewed extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.section = this.closest('[data-rv]') || this;
      const limit = Math.min(MAX, Math.max(1, parseInt(this.dataset.limit, 10) || 4));
      const handles = read().filter((h) => h !== this.dataset.current).slice(0, limit);
      if (handles.length) this.load(handles); else this.empty();
    }

    async load(handles) {
      try {
        const q = handles.map((h) => `handle:${h}`).join(' OR ');
        const r = await fetch(`${this.dataset.url}?q=${encodeURIComponent(q)}&type=product&section_id=recently-viewed`, { credentials: 'same-origin' });
        if (!r.ok) throw new Error(String(r.status));
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const items = [...doc.querySelectorAll('[data-rv-items] > li[data-handle]')];
        if (!items.length) return this.empty();

        // forget products that no longer exist (only when the request clearly worked)
        const found = new Set(items.map((li) => li.dataset.handle));
        const gone = handles.filter((h) => !found.has(h));
        if (gone.length) write(read().filter((h) => !gone.includes(h)));

        const list = this.querySelector('[data-rv-items]');
        const nodes = items.map((li) => {
          li.querySelectorAll('script').forEach((s) => s.remove());   // inert after parsing; the section loads quick-view.js itself
          if (!this.hasAttribute('data-qv-enabled')) li.querySelectorAll('.card__qv').forEach((b) => b.remove());
          li.classList.add('in');
          return document.adoptNode(li);
        });
        list.replaceChildren(...nodes);
        this.section.hidden = false;
      } catch (e) {
        this.empty();
      }
    }

    empty() {
      if (this.hasAttribute('data-design-mode')) return;   // keep the placeholders visible in the theme editor
      this.section.hidden = true;
    }
  }
  customElements.define('loupe-recently-viewed', LoupeRecentlyViewed);
})();
